<template>
    <div class="clearfix company-form-container company-form-container-warapper">
        <div class="company-form-container-title-wrapper">
            <div class="col-sm-12 px-3 company-form-box-title">Provident Fund Settlement List</div>
        </div>
        <div class="col-md-12 company-form-container-content-wrapper">
            <div v-if="em_reg_settlement_list.length>0">
                <common-list  :action_btn_text="action_btn_text" :pageurl="this.$api_url"  :is_pf="is_n_pf"  is_action=0 :appended_column="appended_column" :key="settlement_list_key" :company_options="company_options" :employees="em_reg_settlement_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="settlementListReturn"></common-list>
            </div>
            <div v-else>
                <div v-if="settlement_loader" class="list-no-data">
                    <span class="d-block text-center">Looking for relevant data..</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="list-no-data">
                    Looks like there is no employee to show.
                </div>
            </div>
        </div>
        <b-modal size="lg" class='pf-dereg-details-modal' id="bv-modal-process-settlement-final" hide-footer :title="'Settlement for '+curr_emp_name">
            <b-overlay :show="showoverlay_settle" class='showoverlay_settle' rounded="sm">
                <div class="d-block">
                    
                    <b-form>                    
                        <div class="clearfix">   
                            <div class="row clearfix">
                            <div class="col-md-12 float-left">       
                                <div class="card-body"> 
                                    <div class="employee-table-wrapper">
                                        <div class="upper-block">
                                            <div class="label">Settlement Type</div>
                                            <div class="value"> {{ settlement_fdata.settlement_status }}</div>
                                            <div class="label">Settlement Date</div>
                                            <div class="value">{{ settlement_fdata.settlement_date }}</div>
                                        </div>
                                        <table class="employee-list-table dataTable table-overflow table-sticky">
        
                                        <thead>
                                        <tr class="table-head">
                                            <td class="text-center">
                                                Particulars
                                            </td>
                                            <td class="text-center">
                                                Balance (BDT)
                                            </td>
                                            <td class="text-center">
                                                Settlement Amount (BDT)
                                            </td>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Employer’s contribution to PF
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_salary_fund_employer)}}
                                            </td>
                                            <td class="text-right">
                                                {{ formatMoney(settlement_fdata.salary_contribution_employer) }}
                                            </td>
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Employee’s contribution to PF
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_salary_fund_employee)}}
                                            </td>
                                            <td class="text-right">
                                                {{ formatMoney(settlement_fdata.salary_contribution_employee) }}
                                    
                                            </td>
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Profit balance on employer’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_profit_fund_employer)}}
                                            </td>
                                            <td class="text-right">
                                                {{ formatMoney(settlement_fdata.profit_contribution_employer) }}
                                                
                                            </td>
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Profit balance on employee’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_profit_fund_employee)}}
                                            </td>
                                            <td class="text-right">
                                                {{ formatMoney(settlement_fdata.profit_contribution_employee) }}
                                                
                                            </td>
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Forfeiture balance on employer’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_forfeiture_fund_employer)}}
                                            </td>
                                            <td class="text-right">
                                                {{ formatMoney(settlement_fdata.forfeiture_contribution_employer) }}
                                                
                                                
                                            </td>
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Forfeiture balance on employee’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_forfeiture_fund_employee)}}
                                            </td>
                                            <td class="text-right">
                                                {{ formatMoney(settlement_fdata.forfeiture_contribution_employee) }}
                                               
                                            </td>
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Advance balance
                                            </td>
                                            <td class="text-right">
                                                ({{formatMoney(curr_emp_loan_total)}})
                                            </td>
                                            <td class="text-right">
                                                ({{formatMoney(curr_emp_loan_total)}})
                                            </td>
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Total
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_pf_total_adjusted)}}
                                            </td>
                                            <td class="text-right">
                                                {{curr_emp_settle_balance_show}}
    
                                            </td>
                                        </tr>
                                        </tbody>
                                        </table> 
                    
                                            
                                    </div> 
                                </div>    
                            </div>  
                          </div>                           
                        </div>
            
                    </b-form> 
                </div>
            </b-overlay>
        </b-modal>
    </div>
</template>


<script>
    
    export default{
        
        mounted() {
            
            this.showoverlay = false;
        },
        props: ['flg','pageurl'],
        components: {
           
        },
        data(){            
           
        
            return {
                showoverlay_settle:true,
                curr_emp_name:'',
                settlement_loader:true,
                showoverlay : true,
                settlement_list:[],
                settlement_list_key:0,
                loading:'',
                curr_update_employee:'',
                min_date:'',
                curr_approve_date:"",
                is_n_pf:1,
                action_btn_text:'Details',
                type:['Final Settlement','Partial Settlement'],
                settlement_fdata : {
                  employee_id:0, 
                  id: 0,                       
                },
                /**Child Component property data */
                is_action:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                em_reg_settlement_list:[],  /* Data List */
                default_column:['name','email','employee_code'], /* Default Column List */
                appended_column:[
                    { value: "settlement_date", text: "Settlement Date",type: "date"},
                    // { value: "settlement_amount", text: "Settlement Amount",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "settlement_amount", text: "Settlement Amount",type: "amount"}, // Rejwan: 23-04-2025 2 decimal
                    ],                   /* Appended Column List  and there title and type */
                primary_key:'id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                tmp_custom_list:[],

                custom_array:[],

                /***Child Component property data */


                curr_emp_id: 0,
                curr_emp_pf_total: 0,
                curr_emp_loan_total: 0,
                curr_emp_pf_total_adjusted:0,


                curr_emp_salary_fund: 0,
                curr_emp_salary_fund_employer: 0,
                curr_emp_salary_fund_employee: 0,
                curr_emp_profit_fund: 0,
                curr_emp_profit_fund_employer: 0,
                curr_emp_profit_fund_employee: 0,
                curr_emp_forfeiture_fund: 0,
                curr_emp_forfeiture_fund_employer: 0,
                curr_emp_forfeiture_fund_employee: 0,

                curr_emp_settle_balance: 0,
                curr_emp_settle_balance_show: 0,
               

    
            }
        },
        methods:{
            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return 0;
            },
            resetform()
            {
                this.settlement_fdata = {
                  employee_id:0, 
                  id: 0,                       
                };
            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // },  

            settlementListReturn: function(data)
            {
                this.resetform();
                this.showoverlay_settle = true;
                let currentObj = this;
                let formData = new FormData();
                this.curr_emp_name = data.name;

                var item  = this.em_reg_settlement_list.find(item => item.id === data.id); 
                
                console.log('item'); 
                console.log(item.loan_settlement_balance); 
                console.log(item.id); 

               
                this.settlement_fdata.employee_id = item.employee_id;
                this.settlement_fdata.settlement_date = item.settlement_date;
                this.settlement_fdata.settlement_status = item.status;
                this.settlement_fdata.salary_contribution_employer = item.salary_contribution_company;
                this.settlement_fdata.salary_contribution_employee = item.salary_contribution_employee;
                this.settlement_fdata.profit_contribution_employer = item.profit_contribution_company;
                this.settlement_fdata.profit_contribution_employee = item.profit_contribution_employee;
                this.settlement_fdata.forfeiture_contribution_employer = item.forfeiture_contribution_company;
                this.settlement_fdata.forfeiture_contribution_employee = item.forfeiture_contribution_employee;
                this.curr_emp_settle_balance_show =  item.settlement_amount;
                this.curr_emp_loan_total  =  item.loan_settlement_balance;  
                console.log('settlement_fdata'); 
                console.log(this.settlement_fdata);  

                let employee_id = data.employee_id;
                currentObj.showoverlaymodal = true;
                axios.get(this.$api_url+'/pf/employee/data' , {
                    params: {
								employee_id: data.employee_id,
							}
    
                }).then(function(response){

                    
                    var temp_data = response.data.employee_data;
                    var item = temp_data[employee_id];
                    this.curr_emp_pf_total =item.pf_total;
                    
                    // this.curr_emp_loan_total = item.loan_adjustable;
                    // this.curr_emp_pf_total_adjusted = this.toMoney(this.curr_emp_pf_total) - this.curr_emp_loan_total;
                    // this.curr_emp_salary_fund = item.salary_fund + item.migrated_pf_company_contribution + item.migrated_pf_employee_contribution - item.final_salary_contribution_company - item.final_salary_contribution_employee - item.partial_salary_contribution_employee - item.partial_salary_contribution_company;
                    // this.curr_emp_salary_fund_employer = item.employer_unregistered_provident_fund + item.migrated_pf_company_contribution - item.final_salary_contribution_company - item.partial_salary_contribution_company;
                    // this.curr_emp_salary_fund_employee = item.employee_unregistered_provident_fund + item.migrated_pf_employee_contribution - item.final_salary_contribution_employee - item.partial_salary_contribution_employee;
                    // this.curr_emp_profit_fund = item.profit_fund + item.migrated_pf_profit_employee_contribution + item.migrated_pf_profit_company_contribution - item.final_profit_contribution_employee - item.final_profit_contribution_company - item.partial_profit_contribution_employee - item.partial_profit_contribution_company;
                    // this.curr_emp_profit_fund_employer = item.employee_profit_distrtibuted_fund_company + item.migrated_pf_profit_company_contribution - item.final_profit_contribution_company - item.partial_profit_contribution_company;
                    // this.curr_emp_profit_fund_employee = item.employee_profit_distrtibuted_fund_employee + item.migrated_pf_profit_employee_contribution - item.final_profit_contribution_employee - item.partial_profit_contribution_employee;
                    // this.curr_emp_forfeiture_fund = item.forfeiture_fund + item.migrated_pf_forfeiture_employee_contribution + item.migrated_pf_forfeiture_company_contribution - item.final_forfeiture_contribution_employee - item.final_forfeiture_contribution_company - item.partial_forfeiture_contribution_employee - item.partial_forfeiture_contribution_company;
                    // this.curr_emp_forfeiture_fund_employer = item.employee_forfeiture_distrtibuted_fund_company + item.migrated_pf_forfeiture_company_contribution - item.final_forfeiture_contribution_company - item.partial_forfeiture_contribution_company;
                    // this.curr_emp_forfeiture_fund_employee = item.employee_forfeiture_distrtibuted_fund_employee + item.migrated_pf_forfeiture_employee_contribution - item.final_forfeiture_contribution_employee  - item.partial_forfeiture_contribution_employee;
                
                    currentObj.showoverlay_settle = false;
                    this.$bvModal.show('bv-modal-process-settlement-final');
                    currentObj.showoverlaymodal = false;
                    }.bind(this)).catch(function (error){
                    currentObj.showoverlaymodal = false;
                    console.log(error)
                });
            },
            pfSettlementList: function(index_name='employee_dropdown')
            {
                this.settlement_list = [];
                this.em_reg_settlement_list = [];
               
                let currentObj = this;
                currentObj.settlement_loader = true;
                axios.get(this.$api_url+'/pf/settlement/list' , {
                    params: 
                    {
						settlement_list: 1
					}
                }).then(function(response){

                //this.settlement_list = [];

                if (typeof response.data.employee_data !== 'undefined')
                {
                    /* Assingning the list */ 
                    this.settlement_list = response.data.employee_data;

                    /* Assingning the list */ 
                    this.settlement_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    this.company_options =  response.data.options;
                }
                if (typeof response.data.options !== 'undefined')
                {
                
                }
            
                /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                

                if(this.settlement_list.length > 0 )
                {
                        let emp_ids = []; 
                        this.settlement_list.forEach(pelement => {
                            
                            let dops = []; 

                            let awating = []; 

                             
                            let ii = 0; 
                
                            if(pelement.employee_id > 0)
                            {
                                
                                if(!emp_ids.includes(pelement.employee_id))
                                {
                                    emp_ids.push(pelement.employee_id);
                                    dops = dops.concat([{ label: 'Unsettle' , value: 1 }]);
                                    

                                }
                                
                                pelement.actions = dops; 
                                pelement.pf_total = this.formatMoney(pelement.pf_total);
                                
                                
                                if(pelement.pf_end == '0000-00-00' || pelement.pf_end == '' || pelement.last_payslip == null)
                                {
                                    pelement.pf_end ='';
                                
                                    this.em_reg_settlement_list = this.em_reg_settlement_list.concat(pelement);
                                }
                                else
                                { 
                                    
                                    this.em_reg_settlement_list = this.em_reg_settlement_list.concat(pelement);
                                    

                                    ii++;

                                    
                                        
                                }

                               
                            }
                            else
                            {
                               
                            }
                        });

                    
                }
                else
                {
                    this.blankmsg = "No employee found to De-Register";
                }
                
                //this.reg_custom_list = this.reg_tmp_custom_list;
                this.settlement_list_key = this.settlement_list_key + 1;
                
                currentObj.settlement_loader = false;
                }.bind(this)).catch(function (error){
                    currentObj.settlement_loader = false;
                    console.log(error)
                });
            },
            
        },
        created: function(){
          this.pfSettlementList();
        },
        computed: 
        {
            
        }
    }
</script>

